export * from "./view-package-module/view-package-module.component";